import firebase from 'firebase';

export default {
  namespaced: true,
  state: {
    comments: []
  },
  getters: {
    getComments(state) {
      return state.comments
    }
  },
  mutations: {
    setComments(state, payload) {
      state.comments = payload
    },
    addComment(state, payload) {
      state.comments.push(payload)
    },
    delComment(state, payload) {
      state.comments = state.comments.filter(item => item.id !== payload);
    },
    updateComment(state, payload) {
      const index = state.comments.findIndex(v => v.id === payload.id)
      state.comments.splice(index, 1, payload)
    }
  },
  actions: {
    async addComment({dispatch, commit}, {name, gender, text}) {
      try {
        const response  = await firebase.database().ref('database/comments').push({
          name: name,
          text: text,
          gender: gender
        })
        commit('addComment', {id: response.key, name, gender, text})
      } catch (e) {
        throw e
      }
    },
    async fetchComments({commit}) {
      const comments = (await firebase.database().ref(`/database/comments`).once('value')).val() || {}
      return Object.keys(comments).map(key => ({...comments[key], id: key}))
    },
    async deleteComments({commit}, id) {
      try {
        await firebase.database().ref(`/database/comments/${id}`).remove()
        commit('delComment', id)
      } catch (e) {
        throw e
      }
    },
    async updateComments({commit}, {id, name, gender, text}) {
      try {
        await firebase.database().ref(`/database/comments`).child(id).update({name, gender, text})
        const payload = {id, name, gender, text}
        commit('updateComment', payload)
      } catch (e) {
        throw e
      }
    }
  }
}